export default __webpack_public_path__ + "static/media/ZoneLog_Logger.332f74c4.png";